module.exports = __webpack_public_path__ + "media/application/images/svgs/twitter-631cd5664eb1d4a27681a21ca4ad6126.svg";